import * as React from "react";
import { Loader } from "semantic-ui-react";
import { firebaseDB } from "../firebase";

const { Provider, Consumer } = React.createContext<IState>({
	isLoading: false,
	staticdata: {}
});

interface Data {
	description: string;
	quadrantOrder: string[];
}

interface IState {
	isLoading: boolean;
	staticdata: {
		owners?: Data;
		marketing?: Data;
		operations?: Data;
		strategy?: Data;
	};
}

interface IProps {}

class StaticDataProvider extends React.Component<IProps, IState> {
	state = {
		isLoading: true,
		staticdata: {}
	};

	componentDidMount() {
		this.setState({ isLoading: true });
		const ref = firebaseDB.ref("staticdata");
		ref.on(
			"value",
			snapshot => {
				console.log(snapshot.val());
				this.setState(
					{
						isLoading: false,
						staticdata: {
							...this.state.staticdata,
							...snapshot.val()
						}
					},
					() => console.log(this.state)
				);
			},
			err => {
				throw err;
			}
		);

		// .collection("staticdata")
		// .get()
		// .then(querySnapshot =>
		// 	querySnapshot.forEach(doc => {
		// 		this.setState({
		// 			isLoading: false,
		// 			staticdata: {
		// 				...this.state.staticdata,
		// 				[doc.id]: doc.data()
		// 			}
		// 		} as any);
		// 	})
		// );
	}

	static Consumer = Consumer;

	render() {
		return <Provider value={this.state}>{this.props.children}</Provider>;
	}
}

export default StaticDataProvider;

export interface StaticDataProps {
	staticdata: IState["staticdata"];
	isLoaded: boolean;
}

export function withStaticData(Component) {
	return function WithLoggedInRedirect(props) {
		return (
			<Consumer>
				{data => (
					<Component
						{...props}
						isLoaded={!data.isLoading}
						staticdata={data.staticdata}
					/>
				)}
			</Consumer>
		);
	};
}



// WEBPACK FOOTER //
// ./src/helpers/StaticDataProvider.tsx